import { WORKFLOW_REVIEW_TOKENS } from './workflow-review-token.catalog';
import {
  TERMINOLOGY_CONFIGURATION_CODES,
  TERMINOLOGY_USAGE_KINDS,
  defineTerminologyUsage,
} from './terminology-usage';

function group(
  prefix: string,
  componentCode: string,
  surfaceCode: string,
  route: string,
) {
  const surface = {
    featureCode: 'workflow-runtime',
    surfaceCode,
    componentCode,
    locations: [{ kind: 'route' as const, value: route }],
  };
  const usage = (
    name: string,
    token: (typeof WORKFLOW_REVIEW_TOKENS)[keyof typeof WORKFLOW_REVIEW_TOKENS],
    fallbackText: string,
    kind = TERMINOLOGY_USAGE_KINDS.formLabel as
      | 'form-label'
      | 'component-input',
  ) =>
    defineTerminologyUsage({
      usageId: `${prefix}.${name}`,
      configurationCode: TERMINOLOGY_CONFIGURATION_CODES.programPack,
      token,
      fallbackText,
      kind,
      surface,
    });
  return Object.freeze({
    workSummary: usage(
      'work-summary.label',
      WORKFLOW_REVIEW_TOKENS.workflowReviewWorkSummary,
      'Work submitted for review',
    ),
    outcome: usage(
      'outcome.label',
      WORKFLOW_REVIEW_TOKENS.workflowReviewOutcome,
      'Review outcome',
    ),
    notes: usage(
      'notes.label',
      WORKFLOW_REVIEW_TOKENS.workflowReviewNotes,
      'Review notes',
    ),
    approved: usage(
      'outcome.approved.option',
      WORKFLOW_REVIEW_TOKENS.workflowReviewApproved,
      'Approved',
      TERMINOLOGY_USAGE_KINDS.componentInput,
    ),
    changesRequired: usage(
      'outcome.changes-required.option',
      WORKFLOW_REVIEW_TOKENS.workflowReviewChangesRequired,
      'Changes required',
      TERMINOLOGY_USAGE_KINDS.componentInput,
    ),
  });
}
export const WORKFLOW_WORKSPACE_REVIEW_TERMINOLOGY = group(
  'workflow.workspace.review',
  'WorkflowWorkspaceComponent',
  'workflow-workspace-review',
  '/workflows',
);
export const WORKFLOW_DIAGNOSTICS_REVIEW_TERMINOLOGY = group(
  'workflow.diagnostics.review',
  'WorkflowExecutionPanelComponent',
  'workflow-diagnostics-review',
  '/platform-admin/workflow-registry',
);
